import { Injectable, inject } from "@angular/core";
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpHeaders,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { AppReleaseService } from "@app/shared/services/app-release.service";

// Gives the release header of each response, the error answers too, to AppReleaseService. A
// response without the header, such as one from another origin, tells nothing about the release.
@Injectable()
export class AppReleaseHttpInterceptor implements HttpInterceptor {
    private readonly appRelease = inject(AppReleaseService);

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            tap({
                next: (event) => {
                    if (event instanceof HttpResponse) {
                        this.observe(event.headers);
                    }
                },
                error: (error) => {
                    if (error instanceof HttpErrorResponse) {
                        this.observe(error.headers);
                    }
                },
            })
        );
    }

    private observe(headers: HttpHeaders): void {
        const release = headers.get("X-Cerrix-Release");
        if (release) {
            this.appRelease.observe(release);
        }
    }
}
